export var IContractStatementtype;
(function (IContractStatementtype) {
    IContractStatementtype["CONTRACT"] = "Contract";
    IContractStatementtype["BILL"] = "Bill";
    IContractStatementtype["MARGIN"] = "Margin";
    IContractStatementtype["AGTS"] = "AGTS";
})(IContractStatementtype || (IContractStatementtype = {}));
export var IContractStatementSegment;
(function (IContractStatementSegment) {
    IContractStatementSegment["EQ"] = "EQ";
    IContractStatementSegment["MF"] = "MF";
    IContractStatementSegment["FO"] = "FO";
    IContractStatementSegment["CU"] = "CU";
    IContractStatementSegment["CO"] = "CO";
})(IContractStatementSegment || (IContractStatementSegment = {}));
